export const STEP_FIELDS: Record<number, string[]> = {
  0: [
    "fullNameEn",
    "fullNameAr",
    "surname",
    "alias",
    "placeOfBirth",
    "dateOfBirth",
    "presentNationality",
    "presentNationalityArabic",
    "pastNationality",
    "emailAddress",
    "mobileNumber",
    "sect",
    "religion",
    "placeOfEntry",
    "dateOfEntry",
    "sponsorUponEntry",

    "hasServed",
    "countryName",
    "serviceType",
    "rank",
    "durationOfService",
    "militaryServiceStartDate",
    "militaryServiceEndDate",

    "currentSponsor",
    "occupation",
    "occupationAr",
    "officeFax",
    "presentWorkplace",
    "bank",
    "officeTelephone",
    "salary",

    "passportPlaceOfIssue",
    "passportNumber",
    "passportExpiryDate",
    "passportDateOfIssue",

    "emiratesIdNumber",
    "emiratesIdPlaceOfIssue",
    "emiratesIdExpiryDate",
    "emiratesIdDateOfIssue",

    "visaPlaceOfIssue",
    "residenceVisaNo",
    "visaType",
    "visaExpiryDate",
    "visaDateOfIssue",

    "academicQualification",
    "placeOfStudy",
    "university",
    "languagesKnown",
    "certificateDate",
  ],
  1: [
    "spouseName",
    "spouseNationality",
    "spouseBirthPlace",
    "spouseBirthDate",
    "spouseOccupation",
    "spouseWorkPlace",

    "children",

    "fatherName",
    "fatherNationality",
    "fatherBirthPlace",
    "fatherBirthDate",
    "fatherWorkPlace",
    "fatherOccupation",
    "motherName",
    "motherNationality",
    "motherBirthPlace",
    "motherBirthDate",
    "motherWorkPlace",
    "motherOccupation",

    "bloodRelations",

    "friends",

    "zone",
    "ownerName",
    "phoneNo",
    "street",
    "mobileNo",
    "buildingNo",
    "pagerNo",
    "flatNo",
    "poBoxNo",
    "floorNo",
  ],
  2: [
    "prevOccupations",
    "countriesVisited",
    "countriesWorkedIn",

    "typeOfVehicle",
    "licenseNumber",
    "placeOfIssue",
    "licensedBy",
    "dateOfIssue",
    "plateNumber",
    "dateOfLicenseExpiry",
    "plateCode",
  ],
  3: [
    "photograph",
    "passport",
    "visa",
    "hasEmmiratesId",
    "emiratesIdFront",
    "emiratesIdBack",
    "passportBack",
    "passportFront",

    "FOTTEntry",
    "entryPurposeEnglish",
    "entryPurposeArabic",
    "visitorCompanyEnglish",
    "visitorCompanyArabic",
    "sponsorCompanyEnglish",
    "sponsorCompanyArabic",
    "requestingSponsorEmailAddress",
    "uidNumber",
    "securityClearanceValidity",
    "gdpr",

    "signatureAgreement",
    "signatureName",
    "signatureDate",
  ],
};
